/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserClaimReadDto
 */
export interface UserClaimReadDto {
    /**
     * 
     * @type {number}
     * @memberof UserClaimReadDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserClaimReadDto
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof UserClaimReadDto
     */
    clientName: string;
    /**
     * 
     * @type {string}
     * @memberof UserClaimReadDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof UserClaimReadDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof UserClaimReadDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UserClaimReadDto interface.
 */
export function instanceOfUserClaimReadDto(value: object): value is UserClaimReadDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UserClaimReadDtoFromJSON(json: any): UserClaimReadDto {
    return UserClaimReadDtoFromJSONTyped(json, false);
}

export function UserClaimReadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClaimReadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'clientId': json['clientId'],
        'clientName': json['clientName'],
        'type': json['type'],
        'value': json['value'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UserClaimReadDtoToJSON(json: any): UserClaimReadDto {
    return UserClaimReadDtoToJSONTyped(json, false);
}

export function UserClaimReadDtoToJSONTyped(value?: UserClaimReadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'type': value['type'],
        'value': value['value'],
        'description': value['description'],
    };
}

